<template>
  <q-modal v-model="show_report" :content-css="{minWidth: '100vw', minHeight: '100vh'}" no-backdrop-dismiss no-esc-dismiss>
      <q-modal-layout>
          <q-toolbar slot="header">
              <q-btn flat round dense @click="show_report = false" icon="fas fa-times" />
              <q-toolbar-title>
                  {{ title }}
              </q-toolbar-title>
          </q-toolbar>

          <div class="layout-padding">
              <q-tabs v-model="tab" color="secondary" class="shadow-1">
                  <q-tab slot="title" name="completed" icon="fas fa-check" :label="$t('completed')" />
                  <q-tab slot="title" name="audios" icon="fas fa-play" :label="$t('audios')" />
                  <q-tab slot="title" name="stars" icon="far fa-star" :label="$t('comments')" />
                  <q-tab slot="title" name="likes" icon="far fa-thumbs-up" :label="$t('likes')" />
                  <q-tab slot="title" name="favorites" icon="far fa-heart" :label="$t('favorites')" />

                  <q-tab-pane name="completed" class="q-px-lg q-pb-xl" keep-alive>
                      <completed :load="tab === 'completed' && show_report_podcast ? true : false" :id="id" />
                  </q-tab-pane>

                  <q-tab-pane name="audios" class="q-px-lg q-pb-xl" keep-alive>
                      <audios :load="tab === 'audios' && show_report_podcast ? true : false" :id="id" />
                  </q-tab-pane>

                  <q-tab-pane name="stars" class="q-px-lg q-pb-xl" keep-alive>
                      <comments :load="tab === 'stars' && show_report_podcast ? true : false" :id="id" />
                  </q-tab-pane>

                  <q-tab-pane name="likes" class="q-px-lg q-pb-xl" keep-alive>
                      <likes :load="tab === 'likes' && show_report_podcast ? true : false" :id="id" />
                  </q-tab-pane>

                  <q-tab-pane name="favorites" class="q-px-lg q-pb-xl" keep-alive>
                      <favorites :load="tab === 'favorites' && show_report_podcast ? true : false" :id="id" />
                  </q-tab-pane>
              </q-tabs>
          </div>
      </q-modal-layout>
  </q-modal>
</template>

<script>
import Completed from './report/Completed'
import Audios from './report/Audios'
import Comments from './report/Comments'
import Favorites from './report/Favorites'
import Likes from './report/Likes'

export default {
  props: ['show_report_podcast', 'id', 'status', 'title'],

    components: {
        'completed': Completed,
        'audios': Audios,
        'comments': Comments,
        'favorites': Favorites,
        'likes': Likes
    },

    data() {
        return {
            tab: 'completed',
        }
    },

    computed: {
        show_report: {
            get() {
                return this.show_report_podcast
            },
            set() {
                this.$emit('hide_report', '')
                this.tab = 'completed'
            }
        }
    }
}
</script>

<style>

</style>